import { createSelector } from "reselect";

export const isAuthorizedAsUser = (state) => {
  return state.auth.authorized && (state.auth.email && state.auth.email !== 'false');
};

export const isAuthorizedAsGuest = (state) => {
  return state.auth.authorized && (state.auth.email === 'false');
};

export const isAuthStarted = (state) => state.auth.authStarted;
export const getEmail = (state) => state.auth.email;
export const selectAuth = (state) => state.auth;

export const getInitials = createSelector([selectAuth],
  (auth) => {
    if ((!auth.first_name || typeof auth.first_name !== 'string') &&
      (!auth.last_name || typeof auth.last_name !== 'string')) return 'G'; // Guest

    const first = auth.first_name?.trim() || '';
    const last = auth.last_name?.trim() || '';
    const initials = ((first[0] || '') + (last[0] || '')).toUpperCase();

    return initials || 'G';
  }
)
